import { useEffect, useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { FaEdit, FaPowerOff, FaTrash } from 'react-icons/fa';
import { ICategories } from '../Cadastro/Categorias/interface/ICategories';
import globals from '../../Globals.json';
import ModalBootstrap from '../data/Modal';
import Globals from '../../Globals.json';
import { useFetchById } from '../../apiQuery/useFetchById';
import { useAppSelector } from '../../redux/store';
import Loading from '../Loading/Loading';
import { useDeleteData } from '../../apiQuery/useDeleteData';
import { useUpdateData } from '../../apiQuery/useUpdateData';
import { queryClient } from '../../apiQuery/queryClient';

interface Props {
  key?: any;
  category: ICategories;
  onEditItem: (item: ICategories) => void;
  OnAddNewCategorie: (e: boolean) => void;
  handleFetchTree: any;
}

function Tree({
  category,
  onEditItem,
  OnAddNewCategorie,
  handleFetchTree,
}: Props) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const deleteCategory = useDeleteData(['category']);
  const [expand, setExpand] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState<boolean>(false);
  const [uuid, setUuid] = useState<string>('');
  const [uuidCategory, setUuidCategory] = useState<string>('');

  const updateData = useUpdateData(['category']);
  const {
    data: categoryByUuid,
    isLoading: isLoadingCategoryById,
    isError: isErrorCategoryById,
  } = useFetchById<any>(
    'category',
    `${Globals.api.categoriesCompleted}`,
    uuidCategory,
    {
      queryParams: {
        store_id: storeMe?.storeActive?.id,
        paginate: false,
      },
    }
  );

  const handleDelete = async (uuid: string) => {
    deleteCategory.mutate(
      {
        endpoint: globals.api.categoriesAlt,
        id: uuid,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey[0] === 'category',
          });
        },
      }
    );
  };

  const handleActived = (uuid: any) => {
    const oModel = {
      uuid: uuid,
      is_active: category.is_active === true ? false : true,
    };
    updateData.mutate({
      endpoint: globals.api.categoriesAlt,
      id: oModel.uuid,
      payload: oModel,
    });
  };
  const handleModalUuid = (uuid: string) => {
    setUuid(uuid);
    setModalConfirmation(true);
  };

  const handleDeleteItem = () => {
    setModalConfirmation(false);
    handleDelete(uuid);
  };

  useEffect(() => {
    if (isLoadingCategoryById) return;

    const setUuidProduct = (row: any) => {
      if (row !== undefined) {
        onEditItem(categoryByUuid?.data);
      }
    };
    uuidCategory && setUuidProduct(uuidCategory);
  }, [categoryByUuid?.data, isLoadingCategoryById, onEditItem, uuidCategory]);

  if (isLoadingCategoryById) return <Loading />;

  return (
    <>
      <ModalBootstrap
        state={modalConfirmation}
        setState={setModalConfirmation}
        text={
          'Tem certeza de que deseja excluir? Se este item estiver vinculado a algum produto, ele será excluido.'
        }
        handleAction={handleDeleteItem}
      />
      <div className="row ItemTree" style={{ paddingTop: '10px' }}>
        <div
          className={`col ${
            category?.relationships?.children?.length >= 1
              ? 'subCategoryBackGroup'
              : 'categoryBackGroup'
          }`}
        >
          <section
            className="divBackgroundColor"
            style={{ paddingLeft: '10px' }}
          >
            <div className="px-2" style={{ fontSize: '12px' }}>
              {category?.name.toUpperCase()}

              {category?.relationships?.children?.length >= 1 && (
                <button onClick={() => setExpand(!expand)}>
                  {expand ? (
                    <MdKeyboardArrowUp size={20} color="#a1a5b7" />
                  ) : (
                    <MdKeyboardArrowDown size={20} color="#a1a5b7" />
                  )}
                </button>
              )}
            </div>

            <div className="ms-auto">
              <button>
                <FaEdit
                  size={15}
                  color="8e8d8d"
                  onClick={() => setUuidCategory(category.uuid)}
                />
              </button>
              <button className="px-2">
                {category?.relationships?.children?.length >= 1 ? (
                  <FaPowerOff
                    size={15}
                    color={category?.is_active === false ? 'FF6666' : 'green'}
                    onClick={() => handleActived(category?.uuid)}
                  />
                ) : (
                  <FaTrash
                    size={14}
                    color="8e8d8d"
                    onClick={() => handleModalUuid(category.uuid)}
                  />
                )}
              </button>
            </div>
          </section>
        </div>

        <div style={{ display: expand ? 'block' : 'none' }}>
          {category?.relationships?.children?.map((explore: any) => (
            <div
              className="d-flex flex-row-reverse bd-highlight"
              key={explore?.id}
            >
              <Tree
                category={explore}
                onEditItem={onEditItem}
                OnAddNewCategorie={OnAddNewCategorie}
                handleFetchTree={handleFetchTree}
              />
            </div>
          ))}
        </div>
      </div>

      <div style={{ height: '-5px' }}></div>
    </>
  );
}

export default Tree;
